import React from 'react';
import PropTypes from 'prop-types';
import { lowercaseHyphen } from '../../utils/stringConversion';
import contentTypeName, { contentTypePlural } from '../../utils/contentTypeName';
import Button from '../Global/Buttons/Button';

const SearchPrimaryFilter = ({ onClick, value, active }) => (
  <Button
    onClick={() => onClick(contentTypeName(value))}
    classes={`primary-filter-btn text-capitalize ${active && `primary-filter-btn--active bg-${lowercaseHyphen(value)}`}`}
    faux
  >
    {contentTypePlural(contentTypeName(value))}
  </Button>
);

SearchPrimaryFilter.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
};

export default SearchPrimaryFilter;



// WEBPACK FOOTER //
// ./library/app/components/Search/SearchPrimaryFilter.js